import {
	PageInfo,
	DiscountProfile,
	useDeleteDiscountProfileMutation,
	useGetAllDiscountProfilesLazyQuery,
} from "@repo/server-api";
import { useState } from "react";

import { DataSource } from "@repo/legacy/components/shared/lists/DataSource";
import { PaginationModel } from "@repo/legacy/components/shared/lists/PaginationModel";

export function useAllDisountProfilesDataSource(): DataSource<DiscountProfile> {
	const [rows, setRows] = useState<DiscountProfile[]>([]);
	const [rowCount, setRowCount] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [, setPageInfo] = useState<PageInfo | null>(null);
	const [searchBy, setSearchBy] = useState<string>("");
	const [pageModal, setPageModal] = useState<PaginationModel>({
		page: 0,
		pageSize: 10,
	});

	const [deleteDiscountProfile] = useDeleteDiscountProfileMutation({
		onCompleted(data: { deleteDiscountProfile: { boolean: boolean } }) {
			if (data.deleteDiscountProfile.boolean) {
				refresh();
			}
		},
	});

	const [getDiscountProfiles] = useGetAllDiscountProfilesLazyQuery({
		fetchPolicy: "no-cache",
		onCompleted(data: {
			allDiscountProfiles: {
				nodes: DiscountProfile[];
				totalCount: number;
				pageInfo: PageInfo;
			} | null;
		}) {
			setIsLoading(false);
			if (data && data.allDiscountProfiles?.nodes) {
				const tmp = data.allDiscountProfiles.nodes.map((node) => ({
					...(node as unknown as DiscountProfile),
				}));
				setRows(tmp);
				setRowCount(data.allDiscountProfiles.totalCount);
				setPageInfo(data.allDiscountProfiles.pageInfo);
				setIsLoading(false);
			}
		},
	});

	const refresh = () => {
		fetchData(pageModal, searchBy);
	};

	const fetchData = (page: PaginationModel, searchBy: string) => {
		setIsLoading(true);
		setSearchBy(searchBy);
		setPageModal(page);
		getDiscountProfiles({
			variables: {
				first: page.pageSize,
				after: (page.pageSize * page.page).toString(),
				name: searchBy,
			},
		}).then(
			(response: {
				data: {
					allDiscountProfiles: {
						nodes: DiscountProfile[];
						totalCount: number;
						pageInfo: PageInfo;
					} | null;
				} | null;
			}) => {
				if (response.data && response.data.allDiscountProfiles) {
					setRows(response.data.allDiscountProfiles.nodes as DiscountProfile[]);
					setRowCount(response.data.allDiscountProfiles.totalCount);
					setPageInfo(response.data.allDiscountProfiles.pageInfo);
					setIsLoading(false);
				}
			},
		);
	};

	const deleteData = (id: string) => {
		deleteDiscountProfile({ variables: { id } });
	};

	return {
		rows,
		rowCount,
		isLoading,
		fetchData,
		deleteData,
		refresh,
	};
}
